import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { planSettingsFeaturesEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/features/entrypoint.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const planSettingsFeaturesRouteEntry = createPageEntryPoint({
	main: planSettingsFeaturesEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
